<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>Заявки</div>
            </div>
            <div class="panel-body pn">
                <grid-view
                        fixed-header
                        :loader="loader"
                        store-name="bids-list"
                        defaultSort="-id"
                        :extraFields="['sms', 'responsible', 'schedule']"
                >
                    <template #header>
                        <th>ФИО</th>
                        <th>Телефон</th>
                        <th>Комментарий</th>
                        <th>Группа</th>
                        <th>Дата поступления</th>
                        <th>Дата принятия</th>
                        <th>SMS</th>
                        <th>Ответственный</th>
                        <th></th>
                    </template>
                    <template v-slot:row="{ row }">
                        <td><router-link :to="{name: 'clients-edit', params: {id: row.client_id}}">{{row.name}}</router-link></td>
                        <td>{{row.phone}}</td>
                        <td>{{row.comment}}</td>
                        <td class="fs11">
                            <div class="text-center" v-if="row.schedule">
                                {{row.schedule.date | moment('DD.MM.YYYY')}}<br>
                                <span class="badge badge-warning">
                                    {{directions.find((direction) => direction.id === row.schedule.direction_id) ? directions.find((direction) => direction.id === row.schedule.direction_id).name : ''}}
                                    {{row.schedule.time_start | moment('HH:mm', 'HH:mm:SS')}}
                                </span>
                            </div>
                        </td>
                        <td class="fs11">{{row.created_at | dateFormatTimestamp('dd.mm.yyyy HH:MM')}}</td>
                        <td class="fs11">
                            <span v-if="row.pickup_date">{{row.pickup_date | dateFormatTimestamp('dd.mm.yyyy HH:MM')}}</span>
                        </td>
                        <td class="fs11">
                            <span v-if="row.sms">
                                <span v-if="row.sms.status === 1" class="badge badge-success fs11">Доставлено</span>
                                <span v-else class="badge badge-danger fs11">Отклонено</span>
                            </span>
                            <span v-else><span class="badge fs11">Нет</span></span>
                        </td>
                        <td class="fs11 responsible">{{row.responsible ? row.responsible.fullName : ''}}</td>
                        <td>
                            <drop-down-button name="Действие" classes="btn-info btn-sm">
                                <li :class="{disabled: row.status === 1}">
                                    <a v-on:click="bidClose(row)">
                                        Снять ответственного
                                    </a>
                                </li>
                            </drop-down-button>
                        </td>
                    </template>
                </grid-view>
            </div>
        </div>
    </div>
</template>

<script>
    import Bid from "../../models/v2/Bid";
    import Direction from "../../models/Direction";

    export default {
        async beforeMount() {
            await this.loadData();
        },
        async beforeRouteUpdate(to, from, next) {
            next();
            await this.loadData();
        },
        components: {
            gridView: () => import('../data/table/GridView'),
            dropDownButton: () => import('../data/DropDownButton'),
        },
        data() {
            return {
                directions: [],
                loader: Bid.getList,
            };
        },
        methods: {
            async loadData() {
                let directionsResponse;
                [directionsResponse] = await Promise.all([
                    Direction.getList(1, 999),
                ]);
                this.directions = directionsResponse.data;
            },
            async bidClose(bid) {
                if (bid.status === Bid.STATUS_ACTIVE) {
                    return;
                }
                let result;
                try {
                    result = await bid.close();
                } catch (error) {
                    console.error(error);
                    result = false;
                }
                if (result === true) {
                    this.$notify({
                        text: 'Сохранено. Заявка закрыта',
                    });
                } else {
                    this.$notify({
                        type: 'error',
                        text: 'Ошибка закрытия заявки',
                    });
                }
            },
        },
        metaInfo() {
            return {
                title: 'Заявки - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
